import { FC, useMemo, useState } from "react";
import { Button } from "react-bootstrap";
import ConversionRuleModal from "./ConversionRuleModal";
import { parseRuleText } from "./parseRuleText";
import type { Rule, RuleGroup } from "./ConversionRuleBuilder";

interface Props {
  ruleText: string;
  organizationId: number;
  onChange: (ruleText: string) => void;
}

function countConditions(node: Rule | RuleGroup): number {
  if (!("combinator" in node)) return 1;
  return node.rules.reduce((acc, r) => acc + countConditions(r), 0);
}

const ConversionRuleButton: FC<Props> = ({ ruleText, organizationId, onChange }) => {
  const [open, setOpen] = useState(false);
  const hasRule = ruleText.length > 0;

  const conditionCount = useMemo(
    () => (hasRule ? countConditions(parseRuleText(ruleText)) : 0),
    [hasRule, ruleText],
  );
  const tooltip = useMemo(
    () => (hasRule ? JSON.stringify({ rule_text: ruleText }, null, 2) : "Set conversion rule"),
    [hasRule, ruleText],
  );

  return (
    <>
      <Button
        variant={hasRule ? "outline-primary" : "outline-secondary"}
        className="w-100 d-flex align-items-center justify-content-center gap-2"
        style={{
          height: "calc(0.875rem * 1.6 + 0.75rem + 2px)",
          fontSize: "0.875rem",
          lineHeight: 1.6,
          padding: "0.375rem 0.75rem",
        }}
        onClick={() => setOpen(true)}
        title={tooltip}
      >
        <i className="bi bi-funnel" />
        <span>
          {hasRule
            ? `${conditionCount} condition${conditionCount === 1 ? "" : "s"}`
            : "Add rule"}
        </span>
      </Button>

      <ConversionRuleModal
        show={open}
        value={ruleText}
        organizationId={organizationId}
        onClose={() => setOpen(false)}
        onSave={onChange}
      />
    </>
  );
};

export default ConversionRuleButton;
